import { Button } from "antd";
import { LogoutIcon } from "./icons";

import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { logout } from "@redux";

export const LogoutButton = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const handleLogout = async () => {
    await dispatch(logout());
  };
  return (
    <StyledLogout>
      <Button type="primary" icon={<LogoutIcon />} size={"large"} onClick={handleLogout}>
        {t("page.logout")}
      </Button>
      <p>Version 0.0.1</p>
    </StyledLogout>
  );
};
const StyledLogout = styled.div`
  margin-bottom: 2vh;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 20px;
  .ant-btn {
    display: flex;
    justify-content: flex-start;
    column-gap: 4px;
    width: 200px;
    background-color: #8090a9;
  }
`;
